// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__i9m34","boxTitle":"Qualiphy_boxTitle__2rr_r","box":"Qualiphy_box__2Dz-o","toggleWrap":"Qualiphy_toggleWrap__22ZeP"};